import { Grid } from '@material-ui/core';

import { AuthorizedAccountsCard } from '../authorizedAccountsCard';

export const environmentContent = (
  <Grid container spacing={3} alignItems="stretch">
    <Grid item xs={12}>
      <AuthorizedAccountsCard />
    </Grid>
  </Grid>
);
